import React, { useContext, useState } from "react";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import { useTranslation } from "react-i18next";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import "../../styles/styles.css";
import ScDicomCopyToClipboardButton from "../Tools/ScDicomCopyToClipboardButton";
import SaveAsScDicomButton from "../Tools/SaveAsScDicomButton";
import { USERTYPES } from "../../../../constants/Constants";
import userContext from   "../../../../context/users/UserContext";

const SCDICOMDetails = ({ viewportData, viewportIndex, copyToClipboard, handleUploadScDicom}) => {
  const { roles } = useContext(userContext);



  return (
    <>
      <div className="viewport-overlay-sc-dicom">
        {viewportData && (
          <>
            {(roles[0] == USERTYPES.RADIOLOGIST || roles[0] === USERTYPES.SUPERVISOR) && (
            <>
            <span style={{ lineHeight: "15px" }}>
            <ScDicomCopyToClipboardButton viewportIndex={viewportIndex} copyToClipboard={copyToClipboard} />
            </span>

            <span style={{ lineHeight: "15px" }}>
            <SaveAsScDicomButton viewportIndex={viewportIndex} handleUploadScDicom={handleUploadScDicom} />
            </span>

            </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default SCDICOMDetails;
